module.exports = __webpack_public_path__ + "img/background-geon.2c137675.jpg";